<template>
    <ExtendedLayout
        :user="user"
        currentTab="general"
    >

        <Panel>

            <form @submit.prevent="submit">

                <Heading type="h2" classs="mb-2">{{ __('admin::labels.core_information') }}</Heading>

                <FormGroup :label="__('admin::labels.name')" :error="errors.name">
                    <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.email')" :error="errors.email">
                    <Input name="email" type="email" :has-error="exists(errors.email)" v-model="form.email" :required="true" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.private_phone')" :error="errors.private_phone">
                    <Input name="private_phone" type="text" :has-error="exists(errors.private_phone)" v-model="form.private_phone" :required="false" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.password')" :error="errors.password">
                    <Input name="password" type="password" :has-error="exists(errors.password)" v-model="form.password" :required="false" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.role')" :error="errors.role">
                    <Select name="role" :options="roleOptions" :has-error="exists(errors.role)" v-model="form.role" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.personal_identification_number')" :error="errors.personal_identification_number">
                    <Input name="personal_identification_number" type="text" :has-error="exists(errors.personal_identification_number)" v-model="form.personal_identification_number" :required="false" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.born_at')" :error="errors.born_at">
                    <Datepicker name="born_at" :has-error="exists(errors.born_at)" v-model="form.born_at" :required="false" autocomplete="birthday" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.computer_serial_number')" :error="errors.computer_serial_number">
                    <Input name="computer_serial_number" type="text" :has-error="exists(errors.computer_serial_number)" v-model="form.computer_serial_number" :required="false" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.key_card_id')" :error="errors.key_card_id">
                    <Input name="key_card_id" type="text" :has-error="exists(errors.key_card_id)" v-model="form.key_card_id" :required="false" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.slack_workspace')" :error="errors.slack_workspace">
                    <Select name="slack_workspace" :options="slackWorkspaceOptions" :has-error="exists(errors.slack_workspace)" v-model="form.slack_workspace" />
                </FormGroup>

                <FormGroup :error="errors.receives_time_tracking_notifications">
                    <Toggle name="receives_time_tracking_notifications" :label="__('admin::labels.receives_time_tracking_notifications')" :has-error="exists(errors.receives_time_tracking_notifications)" v-model:checked="form.receives_time_tracking_notifications" />
                </FormGroup>

                <UserEmployments
                    v-model="form.employments"
                    :errors="errors"
                    :companyOptions="companyOptions"
                    :departmentOptions="departmentOptions"
                    :organizationLevelOptions="organizationLevelOptions"
                    class="mt-4"
                />

                <Button :loading="form.processing" class="mt-2">
                    {{ __('admin::general.update_model', {'model': __('admin::users.user').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@A/Pages/Users/Edit';

export default {
    components: {
        ExtendedLayout,
    },
    props: {
        errors: Object,
        user: Object,
        roleOptions: Object,
        organizationLevelOptions: Object,
        companyOptions: Object,
        departmentOptions: Object,
        slackWorkspaceOptions: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                name: this.user.name,
                email: this.user.email,
                private_phone: this.user.private_phone,
                password: '',
                role: this.user.role,
                personal_identification_number: this.user.personal_identification_number,
                born_at: this.user.born_at,
                computer_serial_number: this.user.computer_serial_number,
                key_card_id: this.user.key_card_id,
                slack_workspace: this.user.slack_workspace,
                receives_time_tracking_notifications: this.user.receives_time_tracking_notifications,
                employments: this.user.employments || [],
            })
        }
    },
    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    _method: 'patch',
                }))
                .post(this.$route('admin::users.general.update', { user: this.user.id }));
        },
    }
}
</script>
